import { FC } from 'react'

import { KeyResultInput } from '../../../../types'
import { ViewKeyResultItem } from './ViewKeyResultItem'
import { useTranslation } from 'react-i18next'
import { PerProgressBar } from '../../../../components/custom_components/ProgressBar'
import PerText from '../../../../components/custom_components/Text'
import PerSpacer from '../../../../components/custom_components/Spacer'

interface Props {
  keyResults: KeyResultInput[]
}

export const ViewKeyResults: FC<Props> = ({ keyResults }) => {
  const [t] = useTranslation()

  return (
    <>
      <PerText fontSize="l" mb="xxs">
        {t('okr.objective.keyResults.header')}
      </PerText>
      <PerSpacer mb="xs">
        <PerProgressBar tasksDone={keyResults.filter(({ completed }) => completed).length} tasksAll={keyResults.length} />
      </PerSpacer>
      {keyResults.map((kr: KeyResultInput, index: number) => (
        <ViewKeyResultItem key={index} keyResult={kr} />
      ))}
    </>
  )
}
